import script from "./upload-image.vue?vue&type=script&lang=ts&setup=true"
export * from "./upload-image.vue?vue&type=script&lang=ts&setup=true"

import "./upload-image.vue?vue&type=style&index=0&id=5ab2fc3f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ab2fc3f"]])

export default __exports__